import React from "react";

import { useIntl } from "react-intl";

import { AlertProps } from "@/components/molecules/Alert";

type AlertConfig = {
  message: string;
  description: string;
  isVisible: boolean;
  alertProps?: AlertProps;
};

const defaultState: AlertConfig = {
  message: "",
  description: "",
  isVisible: false,
  alertProps: undefined,
};

const useSecondaryAlertConfig = (initialState: Partial<AlertConfig> = {}) => {
  const [config, setConfig] = React.useState<AlertConfig>({
    ...defaultState,
    ...initialState,
  });
  const intl = useIntl();

  const showUrgencyMessagingAlert = React.useCallback(() => {
    setConfig({
      isVisible: true,
      alertProps: {
        appearance: "white",
        isDismissable: false,
        iconPlacement: "center",
      },
      message: intl.formatMessage({
        defaultMessage: "High interest venue",
      }),
      description: intl.formatMessage({
        defaultMessage: "Book now before it's gone",
      }),
    });
  }, [intl]);

  const hideAlert = React.useCallback(() => {
    setConfig(defaultState);
  }, []);

  return {
    secondaryAlertConfig: config,
    showUrgencyMessagingAlert,
    hideSecondaryAlert: hideAlert,
  };
};

export { useSecondaryAlertConfig };
